import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import imgHistory from "../../assets/img_history.png";
import imgHistory1 from "../../assets/img_history_1.jpg";
import imgHistory2 from "../../assets/img_history_2.jpg";
import imgHistory3 from "../../assets/img_history_3.jpg";
import imgHistory4 from "../../assets/img_history_4.jpg";
import imgHistory5 from "../../assets/img_history_5.jpg";
import ScrollOut from "scroll-out";

const History = () => {
    useEffect(() => {
        ScrollOut({
            threshold: 0,
            once: true
        });
    }, []);

    return (
        <>
            <SubHead title="연혁" eng="HISTORY"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <div class="gray-back-bg history">
                        {/* <img src={imgHistory} alt="이미지" /> */}
                        <div className="history-info-wrap" data-scroll>
                            <ul className="history-infos">
                                <li className="top">
                                    <div className="circle_to">
                                        <img src={imgHistory1} alt="이미지" />
                                    </div>
                                </li>
                                <li>
                                    <div className="circle_imgs borN">
                                        <img src={imgHistory2} alt="이미지" />
                                    </div>
                                    <div className="text_box">
                                        <h3>2023</h3>
                                        <ul className="dots">
                                            <li>KT IP Access 운용업무 수행</li>
                                            <li>전원시설 및 분기국사 FM 운용업무 수행</li>
                                        </ul>
                                        <h3>2022</h3>
                                        <ul className="dots">
                                            <li>5G특화망 주파수 할당, 기간통신사업자 승인 </li>
                                            <li>무선망 종합관제 시스템 개발·적용</li>
                                            <li>일학습 병행 우수기업 고용노동부 장관상 수상</li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <div className="circle_imgs">
                                        <img src={imgHistory3} alt="이미지" />
                                    </div>
                                    <div className="text_box">
                                        <h3>2021</h3>
                                        <ul className="dots">
                                            <li>지하철 무선통신시설 유지보수 사업 착수</li>
                                            <li>5G-EYE 특허 출원</li>
                                            <li>ISO45001 인증</li>
                                        </ul>
                                        <h3>2020</h3>
                                        <ul className="dots">
                                            <li>한국서비스대상 종합대상 2년연속 수상</li>
                                            <li>일학습병행제 우수기업 고용노동부 대상수상 </li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <div className="circle_imgs borN">
                                        <img src={imgHistory4} alt="이미지" />
                                    </div>
                                    <div className="text_box">
                                        <h3>2019</h3>
                                        <ul className="dots">
                                            <li>국가재난안전통신망 구축 완료</li>
                                            <li>한국서비스대상 종합대상 수상(무선네트워크운용부문)</li>
                                        </ul>
                                        <h3>2018</h3>
                                        <ul className="dots">
                                            <li>ktMOS북부 법인으로 통합</li>
                                            <li>KT그룹 계열사 편입</li>
                                            <li>평창동계올림픽 5G통신망 운영</li>
                                            <li>ISO9001 인증 획득</li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <div className="circle_imgs">
                                        <img src={imgHistory5} alt="이미지" />
                                    </div>
                                    <div className="text_box">
                                        <h3>2011</h3>
                                        <ul className="dots">
                                            <li>협력사 회사명 변경 MOS강북/MOS강남/MOS강서 </li>
                                        </ul>
                                        <h3>2003</h3>
                                        <ul className="dots">
                                            <li>
                                                협력사 분할, 확대
                                                <br />
                                                - 강북 : ㈜유니넷텍, ㈜엑셀넷
                                                <br />- 강남 : ㈜오엠아이텔레콤, ㈜터치텔
                                            </li>
                                        </ul>
                                        <h3>2001</h3>
                                        <ul className="dots">
                                            <li>
                                                협력사 출범 <br />
                                                - ㈜유니넷텍 <br />- ㈜오엠아이텔레콤
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default History;
